import * as yup from 'yup'

export const whatsappSchema = yup.object().shape({
  whatsapp: yup.string().min(15).required(),
})
